import * as React from 'react'
import { Observable, Subscription } from 'rxjs'

interface IProps<T> {
	subject: Observable<T>
	children: (T) => React.ReactNode
}

interface IState<T> {
	init: boolean
	value: T | null
}

export default class RenderSubject<T> extends React.PureComponent<
	IProps<T>,
	IState<T>
> {
	public state: IState<T> = {
		init: false,
		value: null
	}

	private subscription: Subscription

	public componentDidMount() {
		this.subscribe()
	}

	private subscribe() {
		this.subscription = this.props.subject.subscribe({
			next: value => this.setState({ value, init: true })
		})
	}

	private unsubscribe() {
		if (this.subscription) {
			this.subscription.unsubscribe()
		}
	}

	public componentDidUpdate(prevProps: IProps<T>) {
		if (this.props.subject !== prevProps.subject) {
			this.unsubscribe()
			this.subscribe()
		}
	}

	public componentWillUnmount() {
		this.unsubscribe()
	}

	public render() {
		return this.state.init ? this.props.children(this.state.value) : null
	}
}



// WEBPACK FOOTER //
// ./src/RenderSubject.tsx